import React, { useEffect, useState } from "react";
import ErrorIcon from "@material-ui/icons/Error";
import { Box, CircularProgress } from "@material-ui/core";
import { tesaBlue, tesaDarkRedError } from "../../styles/colors";
import { HttpErrorType } from "../../models/HttpErrorType";

export interface ImageViewProps {
  id: string;
  downloadImage: (id: string) => Promise<string>;
  onHttpError: (error?: HttpErrorType) => void;
}

function ImageView(props: ImageViewProps) {
  const { id, downloadImage, onHttpError } = props;
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setLoading(true);
    downloadImage(id)
      .then(setImage)
      .catch((error) => {
        onHttpError(error);
        setFailed(true);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <CircularProgress variant="indeterminate" style={{ color: tesaBlue }} />;
  }

  if (failed) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" style={{ color: tesaDarkRedError }}>
        <ErrorIcon color="inherit" /> Error loading image
      </Box>
    );
  }

  return <img src={image} alt="" style={{ height: "100%", width: "100%", objectFit: "contain" }} />;
}

export default ImageView;
